import { forwardRef, type HTMLAttributes, type TdHTMLAttributes, type ThHTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

export const Table = forwardRef<HTMLTableElement, HTMLAttributes<HTMLTableElement>>(({ className, ...props }, ref) => (
  <div className="flex h-full grow-0 overflow-x-auto">
    <table ref={ref} className={cn('size-full h-fit max-h-full table-auto', className)} {...props} />
  </div>
))

export const TableHeader = forwardRef<HTMLTableSectionElement, HTMLAttributes<HTMLTableSectionElement>>(
  ({ className, ...props }, ref) => (
    <thead
      ref={ref}
      className={cn('sticky top-0 bg-gray-100 [&_tr]:border-y [&_tr]:border-gray-200', className)}
      {...props}
    />
  )
)

export const TableHead = forwardRef<HTMLTableCellElement, ThHTMLAttributes<HTMLTableCellElement>>(
  ({ className, scope = 'col', ...props }, ref) => (
    <th
      ref={ref}
      scope={scope}
      className={cn('p-3 text-left align-middle text-sm leading-none font-medium text-gray-700 select-none', className)}
      {...props}
    />
  )
)

export const TableHeadWithSpacing = forwardRef<HTMLTableCellElement, ThHTMLAttributes<HTMLTableCellElement>>(
  ({ className, ...props }, ref) => (
    <TableHead ref={ref} className={cn('border-r-2 border-r-white p-1.5 font-bold', className)} {...props} />
  )
)

export const TableBody = forwardRef<HTMLTableSectionElement, HTMLAttributes<HTMLTableSectionElement>>(
  ({ className, ...props }, ref) => <tbody ref={ref} className={cn('bg-white', className)} {...props} />
)

export const TableRow = forwardRef<HTMLTableRowElement, HTMLAttributes<HTMLTableRowElement>>(
  ({ className, ...props }, ref) => (
    <tr ref={ref} className={cn('border-b border-gray-200 transition-colors last:border-y-0', className)} {...props} />
  )
)

export const TableCell = forwardRef<HTMLTableCellElement, TdHTMLAttributes<HTMLTableCellElement>>(
  ({ className, ...props }, ref) => (
    <td ref={ref} className={cn('p-3 align-middle text-sm leading-none font-light text-black', className)} {...props} />
  )
)

export const TableCellWithSpacing = forwardRef<HTMLTableCellElement, ThHTMLAttributes<HTMLTableCellElement>>(
  ({ className, ...props }, ref) => (
    <TableCell ref={ref} className={cn('border-r-2 border-r-white p-1 text-sm leading-none', className)} {...props} />
  )
)
